import utils from '../../../utils';
import fetch from '../../fetch';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}
const columns = utils.columns([
    {key:'$index', label: '序号', width: 75},
    {key:'orgName', label: '所属部门', width: 100},
    {key:'objectName', label: '对象名称', width: 100},
    {key:'finalScore', label: '总分'},
    {key:'scoreGrade', label: '等级'},
    {key:'objectType', label: '对象类型',
    render: (data) => {
        var objectType = JSON.parse(data)
        if(objectType==0){
            return '专业';
        }else if(objectType==1){
            return '教师';
        }else if(objectType==2){
            return '课程';
        }else if(objectType==3){
            return '班级';
        }else if(objectType==4){
            return '学生';
        }else if(objectType==5){
            return '部门';
        }else if(objectType==6){
            return '团队';
        }else {
            return '未知类型';
        }
    } ,
     width: 100},
    {key:'reviewerOne', label: '评审方1', width: 100},
    {key:'auditScore', label: '分数'},
    {key:'weightOne', label: '权重'},
    {key:'reviewerTwo', label: '评审方2', width: 100},
    {key:'reviewScore', label: '分数'},
    {key:'weightTwo', label: '权重'},
    {
        key: 'termName', width: 120,
        label: '学期'
    },
]);;

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('/zgcp/evaluationScore/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const generate = (data) => {
    return fetch.post('/zgcp/evaluationScore/generate', data)
    .then(response => {
        console.log(response.message)
        if (response.code === 200) {
            Modal.success({
                content:  response.message,
              });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('zgcp/evaluationScore/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * 数据导出
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
const exportScore = (keywords) => {
    return fetch.download('/zgcp/evaluationScore/exportScore', keywords, "EVALUATION_SCORE.xls")
}
export default {
    setRefresh,
    onSelect,
    columns,
    querySearch,
    getSelection,
    exportScore,
    generate,
    remove,
    batchRemove
}